module.exports = [
	"报价",
	"采购",
	"厂家",
	"出售",
	"定制",
	"多少钱",
	"供应",
	"价格",
	"降价",
	"哪家好",
	"批发",
	"生产厂家",
	"售后",
	"甩卖",
	"现货",
	"直销",
	"值得信赖",
	"质量好",
	"生产商",
	"供应商",
	"设计",
	"配件",
	"批发商",
	"回收",
	"转让"
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/suffix.json
// module id = 163
// module chunks = 2